
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/antara/tutorials/overview-of-antara-modules-part-ii",
      function () {
        return require("private-next-pages/docs/antara/tutorials/overview-of-antara-modules-part-ii/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/antara/tutorials/overview-of-antara-modules-part-ii"])
      });
    }
  